// Initialize and add the map
function initMap() {
    // The location of Uluru
    const uluru = { lat: 12.9716, lng: 77.5946 };
    // The map, centered at Uluru
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 15,
        center: uluru,
        mapTypeId: "roadmap",
    });
    // The marker, positioned at Uluru
    const marker = new google.maps.Marker({
        position: uluru,
        map: map,
    });
}
initMap()